<template>
  <div class="admin-user-container">
    <!-- 搜索区域 -->
    <div class="search-bar">
      <div class="search-left">
        <el-button-group>
          <el-button
              :type="searchStatus === null ? 'primary' : ''"
              @click="handleStatusChange(null)"
          >全部</el-button>
          <el-button
              :type="searchStatus === true ? 'primary' : ''"
              @click="handleStatusChange(true)"
          >在线</el-button>
          <el-button
              :type="searchStatus === false ? 'primary' : ''"
              @click="handleStatusChange(false)"
          >未在线</el-button>
        </el-button-group>
      </div>
      <div class="search-right">
        <el-input
            style="width: 230px; "
            v-model="searchText"
            placeholder="请输入用户账号或昵称"
            clearable
            @clear="handleSearch"
            @keyup.enter="handleSearch"
        />

        <el-button
            style="width: 80px; margin-left: 10px;"
            type="primary"
            icon="Search"
            @click="handleSearch"
        >搜索</el-button>
      </div>
    </div>

    <!-- 表格展示区域 -->
    <div class="table-area card">
      <div class="table-header">
        <h3 class="table-title">
          <i class="el-icon-user"></i> 用户列表
        </h3>
        <div class="table-actions">
          <el-button size="small" @click="refreshData">
            <i class="el-icon-refresh"></i> 刷新
          </el-button>
        </div>
      </div>

      <el-table
          :data="userList"
          v-loading="loading"
          :cell-style="tableCellStyle"
          :header-cell-style="tableHeaderStyle"
          style="width: 100%"
          border
          stripe
          height="calc(100vh - 270px)"
      >
        <el-table-column v-if="false" prop="id" label="ID" width="10" />
        <el-table-column prop="nickname" label="昵称" width="160" />
        <el-table-column prop="username" label="账号" width="160" />
        <el-table-column prop="phoneCredentials" label="手机号" width="160" />

        <el-table-column label="角色" width="110">
          <template #default="scope">
            <el-tag :type="getRoleTagType(scope.row.role)">
              {{ formatRole(scope.row.role) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="loginIp" label="登录IP" width="150" />

        <el-table-column prop="loginBrowser" label="登录方式" width="120">
          <template #default="scope">
            <el-tag type="warning">{{ formatLoginBrowser(scope.row.loginBrowser) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="loginTime" label="登录时间" width="180">
          <template #default="scope">
            {{ formatTime(scope.row.loginTime) }}
          </template>
        </el-table-column>

        <!-- 备注列 -->
        <el-table-column prop="remark" label="备注" width="120">
          <template #default="scope">
            <span :title="scope.row.remark || '暂无备注'">
              {{ scope.row.remark ? (scope.row.remark.length > 10 ? scope.row.remark.substring(0, 10) + '...' : scope.row.remark) : '暂无备注' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="账号状态" width="110">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '正常' : '封禁' }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 是否在线 -->
        <el-table-column label="是否在线" width="110">
          <template #default="scope">
            <el-tag :type="scope.row.isOnline ? 'success' : 'info'">
              {{ scope.row.isOnline ? '在线' : '未在线' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="280" fixed="right">
          <template #default="scope">
            <!-- 备注按钮 -->
            <el-button
                size="small"
                type="info"
                @click="handleRemark(scope.row)"
            >备注</el-button>

            <!-- 封禁按钮 -->
            <el-button
                size="small"
                type="danger"
                @click="handleBan(scope.row)"
                v-if="scope.row.status !== 2"
            >封禁</el-button>

            <!-- 解封按钮 -->
            <el-button
                size="small"
                type="success"
                @click="handleUnban(scope.row)"
                v-if="scope.row.status === 2"
            >解封</el-button>

            <!-- 下线按钮 -->
            <el-button
                size="small"
                type="primary"
                @click="handleOffline(scope.row)"
                :disabled="!scope.row.isOnline"
            >下线</el-button>

            <!-- 修改密码按钮 -->
            <el-button
                size="small"
                type="warning"
                @click="handleChangePassword(scope.row)"
            >修改密码</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
            v-model:current-page="currentPage"
            :page-size="pageSize"
            :total="total"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
        />
      </div>
    </div>


    <!-- 修改密码对话框 -->
    <el-dialog
        v-model="changePasswordDialogVisible"
        title="修改密码"
        width="400px"
        :before-close="handleCancelChangePassword"
    >
      <el-form
          :model="changePasswordForm"
          :rules="changePasswordRules"
          ref="changePasswordFormRef"
          label-width="80px"
      >
        <el-form-item label="新密码" prop="newPassword">
          <el-input
              v-model="changePasswordForm.newPassword"
              type="password"
              placeholder="请输入新密码"
              show-password
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
              v-model="changePasswordForm.confirmPassword"
              type="password"
              placeholder="请再次输入新密码"
              show-password
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleCancelChangePassword">取消</el-button>
          <el-button type="primary" @click="handleConfirmChangePassword" :loading="changePasswordLoading">
            确认修改
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 添加备注对话框 -->
    <el-dialog
        v-model="remarkDialogVisible"
        title="修改用户备注"
        width="500px"
        :before-close="handleCancelRemark"
    >
      <el-form
          :model="remarkForm"
          :rules="remarkRules"
          ref="remarkFormRef"
          label-width="80px"
      >
        <el-form-item label="用户账号">
          <el-input
              v-model="remarkForm.username"
              disabled
          />
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input
              v-model="remarkForm.nickname"
              disabled
          />
        </el-form-item>
        <el-form-item label="备注内容" prop="remark">
          <el-input
              v-model="remarkForm.remark"
              type="textarea"
              :rows="4"
              placeholder="请输入用户备注信息（最多500字符）"
              maxlength="500"
              show-word-limit
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleCancelRemark">取消</el-button>
          <el-button type="primary" @click="handleConfirmRemark" :loading="remarkLoading">
            保存备注
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted, reactive} from 'vue'
import {ElMessage, ElMessageBox} from 'element-plus'
import request from '@/utils/request'
import dayjs from 'dayjs'

// 响应式数据
const userList = ref([])
const loading = ref(false)
const searchStatus = ref(null)
const searchText = ref('')

// 修改密码响应式数据
const changePasswordDialogVisible = ref(false)
const changePasswordLoading = ref(false)
const changePasswordFormRef = ref(null)
const currentChangeUser = ref(null)

// 分页相关数据
const currentPage = ref(1)
const pageSize = ref(15)
const total = ref(0)

const remarkDialogVisible = ref(false)
const remarkLoading = ref(false)
const remarkFormRef = ref(null)
const currentRemarkUser = ref(null)

// 备注表单数据
const remarkForm = reactive({
  userId: null,
  username: '',
  nickname: '',
  remark: ''
})

// 修改密码弹窗表单数据
const changePasswordForm = ref({
  newPassword: '',
  confirmPassword: ''
})

// 密码验证规则
const changePasswordRules = {
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请确认密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== changePasswordForm.value.newPassword) {
          callback(new Error('两次输入密码不一致'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ]
}

// 备注验证规则
const remarkRules = {
  remark: [
    { max: 500, message: '备注长度不能超过500字符', trigger: 'blur' }
  ]
}

// 获取用户数据
const fetchUserData = async () => {
  try {
    loading.value = true
    const response = await request.get('/user/list')

    if (response.code === '200') {
      userList.value = response.data
      console.log('用户列表数据:', response.data)
    } else {
      ElMessage.error('获取用户数据失败: ' + response.message)
    }
  } catch (error) {
    console.error('请求错误:', error)
    ElMessage.error('获取用户数据失败')
  } finally {
    loading.value = false
  }
}

// 处理备注按钮点击
const handleRemark = (user) => {
  currentRemarkUser.value = user
  remarkForm.userId = user.id
  remarkForm.username = user.username
  remarkForm.nickname = user.nickname
  remarkForm.remark = user.remark || ''
  remarkDialogVisible.value = true
}

// 确认保存备注
const handleConfirmRemark = async () => {
  if (!remarkFormRef.value) return

  try {
    await remarkFormRef.value.validate()
    remarkLoading.value = true

    const response = await request.put('/user/update-remark', {
      userId: remarkForm.userId,
      remark: remarkForm.remark
    })

    if (response.code === '200') {
      ElMessage.success('备注保存成功')
      remarkDialogVisible.value = false

      // 更新本地数据
      const userIndex = userList.value.findIndex(u => u.id === remarkForm.userId)
      if (userIndex !== -1) {
        userList.value[userIndex].remark = remarkForm.remark
      }
    } else {
      ElMessage.error(response.message || '备注保存失败')
    }
  } catch (error) {
    console.error('保存备注失败:', error)
    ElMessage.error('保存备注失败')
  } finally {
    remarkLoading.value = false
  }
}

// 取消备注修改
const handleCancelRemark = () => {
  remarkDialogVisible.value = false
  if (remarkFormRef.value) {
    remarkFormRef.value.resetFields()
  }
  // 重置表单
  remarkForm.userId = null
  remarkForm.username = ''
  remarkForm.nickname = ''
  remarkForm.remark = ''
}

// 处理状态变化
const handleStatusChange = (status) => {
  searchStatus.value = status
  handleSearch()
}

// 刷新方法
const refreshData = () => {
  currentPage.value = 1
  handleSearch()
}

// 搜索用户
const handleSearch = async () => {
  try {
    loading.value = true
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value
    }
    if (searchStatus.value !== null && searchStatus.value !== '') {
      params.isOnline = searchStatus.value
    }
    if (searchText.value) {
      params.searchText = searchText.value
    }

    const response = await request.get('/user/search-users', {params})

    if (response.code === '200') {
      userList.value = response.data.records || response.data
      total.value = response.data.total || 0
    } else {
      console.error('搜索错误:', response)
    }
  } catch (error) {
    console.error('搜索错误:', error)
  } finally {
    loading.value = false
  }
}

// 强制用户下线
const handleOffline = async (user) => {
  try {
    await ElMessageBox.confirm(
        `确定要强制用户 ${user.username} 下线吗？`,
        '下线确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
    )

    const response = await request.put(`/user/offline/${user.id}`)

    if (response.code === '200') {
      ElMessage.success('用户已强制下线')
      handleSearch()
    } else {
      ElMessage.error(response.message || '下线操作失败')
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('下线失败:', error)
      ElMessage.error('下线操作失败')
    }
  }
}

// 修改密码方法
const handleChangePassword = (user) => {
  currentChangeUser.value = user
  changePasswordForm.value.newPassword = ''
  changePasswordForm.value.confirmPassword = ''
  changePasswordDialogVisible.value = true
}

// 确认修改密码
const handleConfirmChangePassword = async () => {
  if (!changePasswordFormRef.value) return

  try {
    await changePasswordFormRef.value.validate()
    changePasswordLoading.value = true

    const response = await request.put('/user/change-password', {
      userId: currentChangeUser.value.id,
      newPassword: changePasswordForm.value.newPassword
    })

    if (response.code === '200') {
      ElMessage.success('密码修改成功')
      changePasswordDialogVisible.value = false
    } else {
      ElMessage.error(response.message || '密码修改失败')
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('修改密码失败:', error)
      ElMessage.error('修改密码失败')
    }
  } finally {
    changePasswordLoading.value = false
  }
}

// 取消修改密码
const handleCancelChangePassword = () => {
  changePasswordDialogVisible.value = false
  if (changePasswordFormRef.value) {
    changePasswordFormRef.value.resetFields()
  }
}

// 封禁用户
const handleBan = async (user) => {
  try {
    await ElMessageBox.confirm(
        `确定要封禁用户 ${user.username} 吗？`,
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
    )

    await request.put(`/user/ban/${user.id}`)
    ElMessage.success('用户已封禁')
    handleSearch()
  } catch (error) {
    if (error !== 'cancel') {
      console.error('封禁失败:', error)
      ElMessage.error('封禁操作失败')
    }
  }
}

// 解封用户
const handleUnban = async (user) => {
  try {
    await ElMessageBox.confirm(
        `确定要解封用户 ${user.username} 吗？`,
        '确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
    )

    const updatedUser = {...user, status: 1}
    await request.put('/user/update', updatedUser)
    ElMessage.success('用户已解封')
    handleSearch()
  } catch (error) {
    if (error !== 'cancel') {
      console.error('解封失败:', error)
      ElMessage.error('解封操作失败')
    }
  }
}

// 格式化登录方式
const formatLoginBrowser = (browser) => {
  if (!browser) return '-'
  if (browser.toLowerCase().includes('chrome')) return 'Chrome'
  if (browser.toLowerCase().includes('firefox')) return 'Firefox'
  if (browser.toLowerCase().includes('safari')) return 'Safari'
  if (browser.toLowerCase().includes('client')) return '客户端'
  return browser
}

// 格式化时间 - 统一格式 YYYY-MM-DD hh:mm:ss
const formatTime = (time) => {
  if (!time) return '-'
  return dayjs(time).format('YYYY-MM' +
      '' +
      '' +
      '-DD hh:mm:ss')
}

// 格式化角色显示
const formatRole = (role) => {
  const roleMap = {
    'SUPERADMIN': '超级管理员',
    'NORMALUSER': '普通用户'
  }
  return roleMap[role] || role
}

// 获取角色标签类型
const getRoleTagType = (role) => {
  const tagTypeMap = {
    'SUPERADMIN': 'danger',
    'NORMALUSER': 'info'
  }
  return tagTypeMap[role] || ''
}

// 表格样式方法
const tableCellStyle = ({ row, column, rowIndex, columnIndex }) => {
  // 可以针对特定列设置样式
  if (column.property === 'loginTime') {
    return {
      color: '#1890ff',
      fontWeight: '500'
    }
  }
  return {}
}

const tableHeaderStyle = ({ row, column, rowIndex, columnIndex }) => {
  return {
    background: '#f8f9fa',
    fontWeight: '600',
    color: '#495057',
    borderBottom: '2px solid #dee2e6'
  }
}

// 当前页码改变
const handleCurrentChange = (newPage) => {
  currentPage.value = newPage
  handleSearch()
}

onMounted(async () => {
  handleSearch()
})

onUnmounted(() => {
  changePasswordDialogVisible.value = false;
});
</script>

<style scoped>
.admin-user-container {
  padding: 20px;
  margin: 0 auto;
}

.card {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}

.search-left {
  flex-shrink: 0;
}

.search-right {
  flex: 1;
  max-width: 400px;
}

/* 表格区域样式 */
.table-area {
  padding: 10px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.table-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-title i {
  color: #409eff;
}

.total-count {
  font-size: 14px;
  font-weight: normal;
  color: #6b7280;
  margin-left: 8px;
}

.table-actions {
  display: flex;
  gap: 8px;
}

/* 表格单元格样式 */
:deep(.el-table) {
  border: 1px solid #e5e7eb;
}

:deep(.el-table th),
:deep(.el-table td) {
  text-align: center;
}

:deep(.el-table .el-table__row:hover > td) {
  background-color: #f9fafb;
}

/* 备注列样式 */
.user-table .remark-cell {
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: help;
}

/* 分页样式 */
.pagination-container {
  padding-top: 10px;
  display: flex;
  justify-content: center;
}

/* 动画效果 */
:deep(.el-table__row:hover) {
  background-color: #f8fafc;
}

:deep(.el-table__body tr.hover-row>td) {
  background-color: #f8fafc !important;
}

/* 滚动条样式 */
:deep(.el-table__body-wrapper::-webkit-scrollbar) {
  width: 6px;
  height: 6px;
}

:deep(.el-table__body-wrapper::-webkit-scrollbar-track) {
  background: #f1f1f1;
  border-radius: 3px;
}

:deep(.el-table__body-wrapper::-webkit-scrollbar-thumb) {
  background: #c1c1c1;
  border-radius: 3px;
}

:deep(.el-table__body-wrapper::-webkit-scrollbar-thumb:hover) {
  background: #a8a8a8;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .admin-user-container {
    padding: 15px;
  }

  .search-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .search-left,
  .search-right {
    max-width: none;
  }

  .search-left {
    display: flex;
    justify-content: center;
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .table-actions {
    align-self: flex-end;
  }
}
</style>